import { all, call, fork, put, takeLatest } from "redux-saga/effects";
import {
  GET_VENDOR_DOCUMENTS_REQUEST,
  UPLOAD_VENDOR_DOCUMENT_REQUEST,
  DELETE_VENDOR_DOCUMENT_REQUEST,
  GET_SHARE_TARGETS_REQUEST,
  SHARE_VENDOR_DOCUMENT_REQUEST,
  UPDATE_VENDOR_DOCUMENT_STATUS_REQUEST,
} from "./type";
import {
  getVendorDocumentsRequest,
  getVendorDocumentsSuccess,
  getVendorDocumentsFailure,
  uploadVendorDocumentSuccess,
  uploadVendorDocumentFailure,
  deleteVendorDocumentSuccess,
  deleteVendorDocumentFailure,
  getShareTargetsSuccess,
  getShareTargetsFailure,
  shareVendorDocumentSuccess,
  shareVendorDocumentFailure,
  updateVendorDocumentStatusSuccess,
  updateVendorDocumentStatusFailure,
} from "./action";
import { handleApiCallException } from "../../shared/action";
import { ApiResponseMessage } from "../../../helper/tosterHelper";
import { DANGER, SUCCESS } from "../../../constant/commonConstants";
import { invokeApi } from "../../../helper/axiosHelper";

function* getVendorDocuments({ payload: data }) {
  try {
    const response = yield call(
      invokeApi,
      "post",
      "/vendorDocumentList",
      data,
      {},
      "vendor"
    );
    if (response.status) {
      yield put(getVendorDocumentsSuccess(response.data));
    } else {
      yield put(getVendorDocumentsFailure(response));
      ApiResponseMessage(response.message, DANGER);
    }
  } catch (error) {
    yield put(getVendorDocumentsFailure(null));
    handleApiCallException(error);
  }
}

function* uploadVendorDocument({ payload: data }) {
  try {
    const response = yield call(
      invokeApi,
      "post",
      "/vendorDocumentUpload",
      data?.formData,
      {},
      "vendor"
    );
    if (response.status) {
      yield put(uploadVendorDocumentSuccess(response));
      ApiResponseMessage(response.message, SUCCESS);
      yield put(getVendorDocumentsRequest(data?.listQuery || {}));
    } else {
      yield put(uploadVendorDocumentFailure(response));
      ApiResponseMessage(response.message, DANGER);
    }
  } catch (error) {
    yield put(uploadVendorDocumentFailure(null));
    handleApiCallException(error);
  }
}

function* deleteVendorDocument({ payload: data }) {
  try {
    const response = yield call(
      invokeApi,
      "post",
      "/vendorDocumentDelete",
      { documentId: data?.documentId },
      {},
      "vendor"
    );
    if (response.status) {
      yield put(deleteVendorDocumentSuccess(response));
      ApiResponseMessage(response.message, SUCCESS);
    } else {
      yield put(deleteVendorDocumentFailure(response));
      ApiResponseMessage(response.message, DANGER);
    }
    yield put(getVendorDocumentsRequest(data?.listQuery || {}));
  } catch (error) {
    yield put(deleteVendorDocumentFailure(null));
    handleApiCallException(error);
  }
}

function* getShareTargets({ payload: data }) {
  try {
    const response = yield call(
      invokeApi,
      "post",
      "/vendorDocumentShareTargets",
      { documentId: data?.documentId },
      {},
      "vendor"
    );
    if (response.status) {
      yield put(getShareTargetsSuccess(response.data));
    } else {
      yield put(getShareTargetsFailure(response));
      ApiResponseMessage(response.message, DANGER);
    }
  } catch (error) {
    yield put(getShareTargetsFailure(null));
    handleApiCallException(error);
  }
}

function* shareVendorDocument({ payload: data }) {
  try {
    const response = yield call(
      invokeApi,
      "post",
      "/vendorDocumentShare",
      {
        documentId: data?.documentId,
        allVendors: !!data?.allVendors,
        vendorIds: data?.vendorIds || [],
        userIds: data?.userIds || [],
      },
      {},
      "vendor"
    );
    if (response.status) {
      yield put(shareVendorDocumentSuccess(response));
      ApiResponseMessage(response.message, SUCCESS);
      yield put(getVendorDocumentsRequest(data?.listQuery || {}));
    } else {
      yield put(shareVendorDocumentFailure(response));
      ApiResponseMessage(response.message, DANGER);
    }
  } catch (error) {
    yield put(shareVendorDocumentFailure(null));
    handleApiCallException(error);
  }
}

function* updateVendorDocumentStatus({ payload: data }) {
  try {
    const response = yield call(
      invokeApi,
      "post",
      "/vendorDocumentStatus",
      { documentId: data?.documentId, isActive: data?.isActive },
      {},
      "vendor"
    );
    if (response.status) {
      yield put(updateVendorDocumentStatusSuccess(response));
      ApiResponseMessage(response.message, SUCCESS);
      yield put(getVendorDocumentsRequest(data?.listQuery || {}));
    } else {
      yield put(updateVendorDocumentStatusFailure(response));
      ApiResponseMessage(response.message, DANGER);
    }
  } catch (error) {
    yield put(updateVendorDocumentStatusFailure(null));
    handleApiCallException(error);
  }
}

export function* watchVendorDocuments() {
  yield takeLatest(GET_VENDOR_DOCUMENTS_REQUEST, getVendorDocuments);
  yield takeLatest(UPLOAD_VENDOR_DOCUMENT_REQUEST, uploadVendorDocument);
  yield takeLatest(DELETE_VENDOR_DOCUMENT_REQUEST, deleteVendorDocument);
  yield takeLatest(GET_SHARE_TARGETS_REQUEST, getShareTargets);
  yield takeLatest(SHARE_VENDOR_DOCUMENT_REQUEST, shareVendorDocument);
  yield takeLatest(
    UPDATE_VENDOR_DOCUMENT_STATUS_REQUEST,
    updateVendorDocumentStatus
  );
}

function* VendorDocumentsSaga() {
  yield all([fork(watchVendorDocuments)]);
}

export default VendorDocumentsSaga;
